import { createSlice } from '@reduxjs/toolkit';

const getSavedSidebarExpanded = () => {
  try {
    const saved = localStorage.getItem('sidebarExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  } catch {
    return true;
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState: {
    sideBarOpened: false,
    sideBarClicked: false,
    responsiveSidebarOpened: true,
    sidebarExpanded: getSavedSidebarExpanded(),
    internetStatus: 'online',
    reconnectIntervalId: null,
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sideBarOpened = !state.sideBarOpened;
    },
    toggleResponsiveSidebarOpen: (state) => {
      state.responsiveSidebarOpened = true;
    },
    toggleResponsiveSidebarClose: (state) => {
      state.responsiveSidebarOpened = false;
    },
    toggleSidebarDeactivated: (state) => {
      state.sideBarOpened = false;
    },
    toggleOpenSidebar: (state) => {
      state.sideBarClicked = true;
    },
    toggleCloseSidebar: (state) => {
      state.sideBarClicked = false;
    },
    toggleSidebarExpanded: (state) => {
      state.sidebarExpanded = !state.sidebarExpanded;
      try {
        localStorage.setItem(
          'sidebarExpanded',
          JSON.stringify(state.sidebarExpanded)
        );
      } catch {
        console.error('Error saving sidebar expanded state');
      }
    },
    setInternetStatus: (state, action) => {
      state.internetStatus = action.payload;
    },
    setReconnectIntervalId: (state, action) => {
      state.reconnectIntervalId = action.payload;
    },
    clearReconnectIntervalId: (state) => {
      window.clearInterval(state.reconnectIntervalId);
      state.reconnectIntervalId = null;
    },
  },
});

const { reducer } = appSlice;

const Actions = appSlice.actions;

const Selectors = {
  whitelabel: (state) => state.app.whitelabel,
  sidebar: (state) => ({
    opened: state.app.sideBarOpened,
    clicked: state.app.sideBarClicked,
    openedResponsive: state.app.responsiveSidebarOpened,
    expanded: state.app.sidebarExpanded,
  }),
  internetStatus: (state) => state.app.internetStatus,
};

export { reducer, Actions, Selectors };
